import { componentMonochrome } from '@arcade/web'
import * as tokens from '@cash-design-system/tokens'

import { ArcadeThemeColorsOverride } from './arcadeColors'
import { ThemeColorsOverride } from './colors'

/**
 * This is a theme that exists soley to override primary button colors, making
 * it black for monochrome.
 */

const monochromePalette = {
  ColorPaletteMediumGrey: '#CCCCCC',
} as const

export const monochromeArcadeColors: Partial<ArcadeThemeColorsOverride> = {
  // monochrome arcade colors
  ...componentMonochrome,

  // Button colors
  buttonProminentBackgroundDefault: {
    light: tokens.ColorPaletteBlack,
    dark: tokens.ColorPaletteWhite,
  },
  buttonProminentTextDefault: {
    light: tokens.ColorPaletteWhite,
    dark: tokens.ColorPaletteBlack,
  },
  buttonProminentBackgroundDisabled: {
    light: monochromePalette.ColorPaletteMediumGrey,
    dark: monochromePalette.ColorPaletteMediumGrey,
  },
  buttonProminentBackgroundHover: {
    light: tokens.ColorPaletteGray40,
    dark: tokens.ColorPaletteGray40,
  },
  buttonProminentBackgroundPressed: {
    light: tokens.ColorPaletteGray40,
    dark: tokens.ColorPaletteGray40,
  },

  // Input colors
  inputBorderSelected: {
    light: tokens.ColorPaletteBlack,
    dark: tokens.ColorPaletteWhite,
  },
  inputCursor: {
    light: tokens.ColorPaletteBlack,
    dark: tokens.ColorPaletteWhite,
  },
}

export const monochromeMooncakeColors = {
  primaryButtonBackground: {
    light: tokens.ColorPaletteBlack,
    dark: tokens.ColorPaletteWhite,
  },
  primaryButtonTint: {
    light: tokens.ColorPaletteWhite,
    dark: tokens.ColorPaletteBlack,
  },
  primaryButtonActive: {
    light: tokens.ColorPaletteGray40,
    dark: tokens.ColorPaletteGray40,
  },
  primaryButtonHover: {
    light: tokens.ColorPaletteGray40,
    dark: tokens.ColorPaletteGray40,
  },
  inputFocusBorder: {
    light: tokens.ColorPaletteBlack,
    dark: tokens.ColorPaletteWhite,
  },
} as ThemeColorsOverride
